import { render, staticRenderFns } from "./ques-blank.vue?vue&type=template&id=6e6a493b&scoped=true"
import script from "./ques-blank.vue?vue&type=script&lang=js"
export * from "./ques-blank.vue?vue&type=script&lang=js"
import style0 from "./ques-blank.vue?vue&type=style&index=0&id=6e6a493b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6a493b",
  null
  
)

export default component.exports